module.exports = "/_next/static/images/Personalization-sm-a335aab16b5956ba9d33696087e9e0d3.webp";